import React, { FC, isValidElement, ReactNode } from "react";
import Voice from "./subpage/voice";
import classNames from "classnames";
import { ScanPageItemEnum, ScanPageHeaderProps, ScanPageHeaderItemEnum } from "../interface";

const Header: FC<ScanPageHeaderProps> = props => {
  const { children, className, style, isVoice, } = props;
  // const renderChildren = (childrenNodes: ReactNode): ReactNode => {
  //   return React.Children.map(childrenNodes, child => {
  //     const childElement = child as React.FunctionComponentElement<ScanPageHeaderProps>;
  //     if (!isValidElement(childElement)) return null;
  //     if (!childElement.type) return null;
  //     const { displayName } = childElement.type;
  //     if (displayName && displayName in ScanPageHeaderItemEnum) {
  //       return React.cloneElement(childElement);
  //     } else {
  //       console.error(
  //         'Warning: ScanPageRight has a child which is not a GoodInfo or GoodItem component',
  //       );
  //     }
  //   });
  // };
  const classes = classNames('scan-page-header', className);
  return (
    <div className={classes} style={style}>
      <div className="scan-page-header-left">
        {children}
      </div>
      {isVoice && (
        <div className="scan-page-header-right"><Voice /></div>
      )}
    </div>
  );
};

Header.displayName = ScanPageItemEnum.Header;
Header.defaultProps = {
  isVoice: true,
};

export default Header;